// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.gw-loader{align-items:center;display:inline-flex}.gw-loader .dn-icon{animation:rotate 2s linear infinite;color:var(--color-gray-500);margin-right:var(--spacing-xs)}.gw-loader--big{color:var(--color-gray-500);font-size:1.5rem;height:30rem;justify-content:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
